<template>
  <div class="box">
    <div class="bottom">
      <voucherHead ref="voucherHead" :formData="BasicsInfo"></voucherHead>
      <voucherRows ref="voucherRow" :dataList="BasicsInfo"></voucherRows>
    </div>
    <div class="btn-item-detail">
      <a v-hasPermi="['2022011115282730313']" class="btn-save" @click="save()"
        ><svg-icon
          :class="{ 'icon-img-admin': true }"
          style="font-size: 14px"
          icon-class="icon-preserve"
        />保存</a
      >
    </div>
  </div>
</template>

<script>
  import voucherHead from './components/voucherHead';
  import voucherRows from './components/voucherRows';
  export default {
    name: 'voucherDetail',
    components: {
      voucherHead,
      voucherRows,
    },
    mounted() {
      this.loadData();
    },
    data() {
      return {
        BasicsInfo: {
          detailList: [],
        },
      };
    },
    methods: {
      async loadData() {
        if (this.$route.query.type === 'edit') {
          await this.$axios
            .post('/financial/tAeVoucherHeaderTemplate/queryById', { id: this.$route.query.id })
            .then((res) => {
              this.BasicsInfo = res.data.data;
            });
        }
      },
      async save() {
        let data = {};
        if (this.$refs.voucherHead.submit()) {
          data = this.$refs.voucherHead.voucherHeadData;
        } else {
          return;
        }
        data.detailList = this.$refs.voucherRow.getData();
        let params = {
          ...data,
        };
        this.$confirmAction('是否保存', '')
          .then(() => {
            this.$axios.post('/financial/tAeVoucherHeaderTemplate/save', params).then(() => {
              this.$message({ showClose: true, type: 'success', message: '保存成功' });
            });
          })
          .catch(() => {
            this.$message({ showClose: true, type: 'info', message: '取消保存' });
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  .box {
    background-color: #ffffff;
    padding: 20px 30px;
  }
  .form-box {
    padding: 18px 0 0;
    .el-form-item {
      width: 25%;
      ::v-deep .el-form-item__label {
        width: 90px;
      }
      ::v-deep .el-form-item__content {
        margin-left: 90px;
      }
      ::v-deep .el-select {
        width: 100%;
      }
      ::v-deep .el-date-editor {
        width: 100%;
      }
    }
    .item {
      display: flex;
      flex-wrap: wrap;
      line-height: 100px;
      align-items: center;
    }

    .check-box {
      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #409eff;
        border-color: #409eff;
      }
      ::v-deep .el-checkbox__inner:hover {
        border-color: #00b400;
      }
      ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #00b400;
      }
    }
  }

  .bottom {
    padding: 10px;
    border: 1px solid #dcdfe6;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 0 6px 0 rgba(0, 0, 0, 0.1);
  }

  .btn-item-detail {
    padding-top: 20px;
    text-align: center;
  }
</style>
